require('js-cookie');
require('bootstrap-datepicker');
require('slick-carousel');

require('./cookie-banner');
require('./shop');
require('./base');
